<!--完成收款弹窗形式 销售 收款 -->
<template>
    <div v-loading="loading">
        <el-form :rules="rules" :model="submitData" label-width="100px" ref="submitData">
            <el-row :gutter="20">
                <el-col :span="6">
                    <div class="grid-content bg-purple">
                        <el-form-item :label="confirmData.OrderType == 0 ? '销售总额' : '退款总额'">
                            <el-input v-model="allMoney" disabled></el-input>
                        </el-form-item>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="grid-content bg-purple">
                        <el-form-item :label="confirmData.OrderType == 0 ? '应收总额' : '应退总额'">
                            <el-input v-model="hjMoney" disabled></el-input>
                        </el-form-item>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="grid-content bg-purple">
                        <el-form-item :label="confirmData.OrderType == 0 ? '实收金额' : '实退金额'" prop="ActualMoney">
                            <el-input ref="acmoney" type="number" step="1" v-model="submitData.ActualMoney" :min="0"></el-input>
                        </el-form-item>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="grid-content bg-purple">
                        <el-form-item label="结算方式" prop="PayType">
                            <el-select v-model="submitData.PayType" placeholder="请选择" style="width: 100%" @change="payTypeSelected">
                                <el-option v-for="item in payWayList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="10">
                    <div class="grid-content bg-purple">
                        <el-form-item label="物流公司" prop="LogisticId">
                            <el-select
                                style="width: 100%"
                                v-model="submitData.LogisticId"
                                value-key="EntpCusId"
                                placeholder="请输入物流公司"
                                filterable
                                clearable
                                default-first-option
                                remote
                                reserve-keyword
                                :remote-method="searchLogistic"
                                @visible-change="logisticVisibleChange($event)"
                                v-select-scroll-more="searchLcLoad"
                                @change="logisticChange"
                            >
                                <el-option v-for="item in logisticsList" :key="item.EntpCusId" :data-msg="item" :label="item.EntpCusName" :value="item.EntpCusId">
                                    <div class="name">
                                        {{ item.EntpCusName }}
                                        <span class="phone" v-if="item.Phone">
                                            {{ ' ( 电话：' + item.Phone + ' )' }}
                                        </span>
                                    </div>
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </el-col>
                <el-col :span="14">
                    <div class="agent-view">
                        <el-form-item label="备注" class="grid-content bg-purple">
                            <el-input v-model="submitData.Remark"></el-input>
                        </el-form-item>
                        <div class="agent-checked" v-if="confirmData.OrderType == 0">
                            <el-checkbox v-model="submitData.IsAgent">是否代收？</el-checkbox>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </el-form>
        <div class="btn-ctn">
            <el-button size="small" class="search-btn" @click="cancel()">取消</el-button>
            <el-button size="small" class="search-btn btn-primary" @click="submitForm()" :disabled="!canSubmit">提交确认</el-button>
        </div>
    </div>
</template>
<script>
export default {
    name: '',
    props: ['confirmData'],
    components: {},
    data() {
        return {
            loading: true,
            allMoney: 0,
            hjMoney: 0,
            payWayList: [],
            dsChecked: false,
            submitData: {
                OrderId: '',
                ActualMoney: '',
                PayType: '',
                Remark: '',
                IsAgent: false,
                LogisticId: '',
                LogisticName: ''
            },
            rules: {
                PayType: [{ required: true, message: '该项必填', trigger: 'blur' }],
                ActualMoney: [{ required: true, message: '该项必填', trigger: 'blur' }]
            },
            canSubmit: true, // 是否可以提交
            logisticsList: [],
            // 用于物流公司列表，分页搜索
            lcForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            }
        };
    },
    mounted() {
        let that = this;
        if (that.confirmData) {
            that.checkOrderAmount(that.confirmData.OrderId, that.confirmData.OrderType).then(data => {
                if (data) {
                    that.allMoney = data.OrderAmount.toFixed(2);
                    that.hjMoney = data.ActualAmount.toFixed(2);
                } else {
                    that.allMoney = that.confirmData.OrderAmount.toFixed(2);
                    that.hjMoney = (that.confirmData.OrderAmount + that.confirmData.ShipAmount - that.confirmData.DiscountAmount).toFixed(2);
                }

                if (that.confirmData.PayType) {
                    that.submitData.PayType = that.confirmData.PayType;
                }
                that.submitData.OrderId = that.confirmData.OrderId;
                that.submitData.ActualMoney = that.hjMoney;
                if (that.confirmData.LogistId) {
                    that.submitData.LogisticId = that.confirmData.LogistId;
                    that.submitData.LogisticName = that.confirmData.LogistName;
                    that.logisticsList.push({ EntpCusId: that.submitData.LogisticId, EntpCusName: that.submitData.LogisticName, Phone: '' });
                }
                that.$util.getPay().then(data => {
                    that.payWayList = data;
                });
                this.loading = false;
            });
        } else {
            that.$util.warningMsg('单据数据异常，请刷新后重新操作');
            that.loading = false;
        }
        if (that.$refs.acmoney) that.$refs.acmoney.focus();
    },
    methods: {
        cancel() {
            this.$emit('closeConfirm');
        },
        submitForm() {
            // if (this.submitData.ActualMoney < 0) {
            //     this.$util.warningMsg('实收金额不能小于0');
            //     return;
            // }
            if (!this.submitData.PayType) {
                this.$util.warningMsg('请选择结算方式');
                return;
            } else {
                let ind = this.payWayList.filter(f => f.Value === this.submitData.PayType);
                if (ind && ind.length > 0) {
                    if (ind[0].IsSecSpecial) {
                        if (!this.submitData.LogisticName) {
                            this.$util.warningMsg('当前单据没有关联物流公司，请勿选择托收类型的结算方式');
                            return;
                        }
                    }
                }
            }
            if (this.submitData.ActualMoney == 0) {
                let title = '';
                title = '实收金额当前等于0，仍确定要提交吗？';

                this.$confirm(title, '提示', {
                    confirmButtonText: '确定继续提交',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                    .then(() => {
                        this.$refs['submitData'].validate(valid => {
                            if (valid) {
                                this.loading = true;
                                this.canSubmit = false;
                                this.$util
                                    .axiosPost({
                                        url: '/api/RevenueManagement_H/ConfirmDBCheckSaleOrders',
                                        data: this.submitData,
                                        hideLoading: true
                                    })
                                    .then(res => {
                                        this.$util.successMsg(res.errmsg);
                                        this.$emit('closeConfirm', res.data, this.submitData.ActualMoney);
                                    })
                                    .catch(() => {
                                        this.canSubmit = true;
                                        this.loading = false;
                                    });
                            } else {
                                return false;
                            }
                        });
                    })
                    .catch(() => {});
            } else {
                this.$refs['submitData'].validate(valid => {
                    if (valid) {
                        this.canSubmit = false;
                        this.$util
                            .axiosPost({
                                url: '/api/RevenueManagement_H/ConfirmDBCheckSaleOrders',
                                data: this.submitData
                            })
                            .then(res => {
                                this.$util.successMsg(res.errmsg);
                                this.$emit('closeConfirm', res.data, this.submitData.ActualMoney);
                            })
                            .catch(() => {
                                this.canSubmit = true;
                            });
                    } else {
                        return false;
                    }
                });
            }
        },
        payTypeSelected(val) {
            let that = this;
            let ind = that.payWayList.filter(f => f.Value === val);
            if (ind && ind.length > 0) {
                if (ind[0].IsSecSpecial) {
                    if (!that.submitData.LogisticName) {
                        that.$util.warningMsg('当前单据没有关联物流公司，请勿选择托收类型的结算方式');
                    }
                }
            }
        },
        logisticVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.logisticsList.length == 0) that.searchLogistic();
            }
        },
        searchLogistic(key) {
            if (![undefined].includes(key)) {
                this.lcForm.Page = 1;
                this.lcForm.stopLoad = false;
                this.lcForm.key = key;
                this.logisticsList = [];
            }
            if (this.lcForm.stopLoad) return;
            this.$util
                .searchLogistic(this.lcForm.key, this.lcForm.Page, this.lcForm.Limit)
                .then(res => {
                    let data = res;
                    if (!data) return;
                    this.lcForm.stopLoad = data.length < this.lcForm.Limit;
                    this.logisticsList = [...this.logisticsList, ...data];
                })
                .catch(() => {});
        },
        searchLcLoad() {
            this.lcForm.Page += 1;
            this.searchLogistic();
        },
        logisticChange(val) {
            if (!val) {
                this.submitData.LogisticName = '';
            } else {
                let logist = this.logisticsList.find(e => e.EntpCusId == val);
                if (logist) {
                    this.submitData.LogisticName = logist.EntpCusName;
                }
            }
        },
        checkOrderAmount(orderId, orderType) {
            return new Promise(resolve => {
                this.$util
                    .axiosPost({
                        url: '/api/RevenueManagement_H/CheckOrderAmount',
                        data: { OrderId: orderId, OrderType: orderType },
                        hideLoading: true
                    })
                    .then(res => {
                        resolve(res.data);
                    })
                    .catch(res => {
                        resolve();
                    });
            });
        }
    }
};
</script>
<style lang="less" scoped>
.dialog-content {
    margin: 5px;
}
.btn-ctn {
    text-align: right;
}
.el-row {
    margin-bottom: 0px;
    &:last-child {
        margin-bottom: 0;
    }
}
.agent-view {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .grid-content {
        flex: 1;
    }

    .agent-checked {
        margin-left: 24px;
    }
}
</style>
